import {useEffect} from "react";
import {Icon} from "leaflet";
import "leaflet/dist/leaflet.css";
import {MapContainer, Marker, TileLayer, useMap} from "react-leaflet";

import {cn} from "@/lib/utils";

const markerIcon = new Icon({
  iconUrl: "/assets/location.png",
  iconSize: [35, 35],
});

type MapEmbedProps = {
  position: [number, number];
  className?: string;
};

function MapViewSync({position}: {position: [number, number]}) {
  const map = useMap();
  const [lat, lng] = position;

  useEffect(() => {
    map.setView([lat, lng], map.getZoom() ?? 15, {animate: false});
  }, [lat, lng, map]);

  return null;
}

export function MapEmbed({position, className = "h-[18rem]"}: MapEmbedProps) {
  const [lat, lng] = position;

  return (
    <div className={cn("relative z-0 overflow-hidden rounded-md", className)}>
      <MapContainer
        key={`${lat},${lng}`}
        center={position}
        zoom={15}
        scrollWheelZoom={false}
        className="h-full w-full"
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapViewSync position={position} />
        <Marker position={position} icon={markerIcon} />
      </MapContainer>
    </div>
  );
}
